export default __webpack_public_path__ + "static/media/kitchen1-1024w.b1704905.png";